import script from "./AdminComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminComponent.vue?vue&type=script&lang=ts&setup=true"

import "./AdminComponent.vue?vue&type=style&index=0&id=47b53fc6&lang=scss"

const __exports__ = script;

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QOptionGroup,QCheckbox});qInstall(script, 'directives', {ClosePopup});
